import {connect} from 'react-redux';
import BaseFeature from './BaseFeature';
import {cn} from 'lib/utils';
import {SENSOR_MODE} from '../../../../../../utils/constantFeatures';
import {getErrorIssues, getWarningIssues} from '../../../../../../utils/validationSummary';
import SensorSettingsCluster from './molecules/SensorSettingsCluster';
import SensorTimingCluster from './molecules/SensorTimingCluster';
import SensorGraphCluster from './molecules/SensorGraphCluster';

class SensorMode extends BaseFeature {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        this.props.handleChange(propertyName, value);
    }

    // Same error/warning signal as BaseFeature.getClassName, minus the legacy
    // .card-feature-component base class (that one is width:fit-content, which is what
    // the modern cards are getting away from). `.danger` / `.warning` are standalone
    // border rules in stylesheet.css, so they still apply as-is.
    cardState(properties) {
        if (getErrorIssues(this.props.issues, properties).length > 0) return 'danger';
        if (getWarningIssues(this.props.issues, properties).length > 0) return 'warning';
        return '';
    }

    render() {
        const {properties} = this.props;

        const silentDimmingLevel = properties[SENSOR_MODE.silentDimmingLevel];
        const occupyDimmingLevel = properties[SENSOR_MODE.occupyDimmingLevel];
        const triggerVoltage = properties[SENSOR_MODE.triggerVoltage];
        const detectionLogic = properties[SENSOR_MODE.detectionLogic];
        const fadingInTime = properties[SENSOR_MODE.fadingInTime];
        const holdUpTime = properties[SENSOR_MODE.holdUpTime];
        const fadingOutTime = properties[SENSOR_MODE.fadingOutTime];

        return (
            // Same wrapper, grid and spans as AstroDimSensor / AstroDim5 on purpose:
            // Sensor Settings and Sensor Timing are the same cards on all three screens,
            // and users switch between them in the sidebar — so they must not change
            // width as you move around. Unlike astdimsens, this opmode DOES use the two
            // global dimming levels, so all four Sensor Settings rows render here.
            <div className="mx-auto w-full max-w-[1800px] px-4 pb-4">
                <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 xl:grid-cols-12">

                    <SensorSettingsCluster
                        variant="modern"
                        silentDimmingLevel={silentDimmingLevel}
                        occupyDimmingLevel={occupyDimmingLevel}
                        triggerVoltage={triggerVoltage}
                        detectionLogic={detectionLogic}
                        className={cn('lg:col-span-1 xl:col-span-4', this.cardState([silentDimmingLevel, occupyDimmingLevel, triggerVoltage, detectionLogic]))}
                        handleChange={this.handleChange}/>

                    <SensorTimingCluster
                        variant="modern"
                        fadingInTime={fadingInTime}
                        holdUpTime={holdUpTime}
                        fadingOutTime={fadingOutTime}
                        className={cn('lg:col-span-1 xl:col-span-3', this.cardState([fadingInTime, holdUpTime, fadingOutTime]))}
                        handleChange={this.handleChange}/>

                    <SensorGraphCluster
                        className="lg:col-span-3 xl:col-span-12"
                        silentDimmingLevel={silentDimmingLevel}
                        occupyDimmingLevel={occupyDimmingLevel}
                        fadingInTime={fadingInTime}
                        holdUpTime={holdUpTime}
                        fadingOutTime={fadingOutTime}
                        issues={this.props.issues}
                        properties={properties}
                        handleChange={this.handleChange}/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    issues: state.project.issueByProperty,
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SensorMode);
